export default __webpack_public_path__ + "static/media/GGB-hero_grey_1950x1201_copy-compressor-1.d2130d49.png";